import { ComponentFactory } from 'survey-vue3-ui';
import SurveyFileItem from '@/components/licenses/SurveyFileItem.vue';

/** Use direct authorized downloads for saved files while retaining SurveyJS's local upload controls. */
export function registerSurveyFiles() {
  ComponentFactory.Instance.registerComponent('sv-file-item', SurveyFileItem);
}
